/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Summary_Reading_Rate_LabelInputs */



/**
* | output |
* | --- |
* | "Reading Rate" |
*
* @param {Summary_Reading_Rate_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const summary_reading_rate_label = /** @type {((inputs?: Summary_Reading_Rate_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Summary_Reading_Rate_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Taux de lecture")
	if (locale === "de") return /** @type {LocalizedString} */ ("Lesegeschwindigkeit")
	if (locale === "it") return /** @type {LocalizedString} */ ("Velocità di lettura")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Скорость чтения")
	if (locale === "es") return /** @type {LocalizedString} */ ("Velocidad de lectura")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("阅读速度")
	if (locale === "ja") return /** @type {LocalizedString} */ ("読書速度")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पठन दर")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Taxa de leitura")
	return /** @type {LocalizedString} */ ("Reading Rate")
});